require('./bootstrap');


import Vue from 'vue';
import Slot from '@/components/Slot';

import { RayPlugin } from 'vue-ray/vue2';
Vue.use(RayPlugin, { interceptErrors: true, host: '127.0.0.1', port: 23517 });

/**
 * Make url() accesible in Vue templates
 */
Vue.prototype.url = url;

const store = Vue.observable({
    slot: new Slot,
    updateReservationModal: null,
    openSlots: [],
    reservations: [],
    occupiedSlots: [],
});

Vue.prototype.$store = store;


/**
 * Global events
 */
window.events = new Vue();

Vue.component('dropdown', require('./components/Dropdown').default);
Vue.component('partial', require('./components/Partial').default);
Vue.component('icon', require('./components/Icon').default);
Vue.component('btn', require('./components/Btn').default);
Vue.component('trigger', require('./components/Trigger').default);
Vue.component('toastr', require('./components/Toastr').default);
Vue.component('tooltip-button', require('./components/TooltipButton').default);
Vue.component('stars-input', require('./components/StarsInput').default);
Vue.component('stars-rating', require('./components/StarsRating').default);
Vue.component('selectbox-filter', require('./components/SelectboxFilter').default);
Vue.component('date-range-filter', require('./components/DateRangeFilter').default);
Vue.component('user-search-filter', require('./components/UserSearchFilter').default);

Vue.component('sidebar', require('./Sidebar').default);
Vue.component('user-login', require('./UserLogin').default);
Vue.component('user-form', require('./UserForm').default);
Vue.component('user-options', require('./UserOptions').default); Vue.component('upload-button', require('./UploadButton').default);
Vue.component('file-toggle-public', require('./FileTogglePublic').default);
Vue.component('conversation', require('./Conversation').default);
Vue.component('conversation-index', require('./ConversationIndex').default);
Vue.component('conversation-toggle-archived', require('./ConversationToggleArchived').default);
Vue.component('unread-conversations-badge', require('./UnreadConversationsBadge').default);

Vue.component('modal', require('./Modal').default);

Vue.component('resource-form', require('./ResourceForm/Index').default);
Vue.component('resource-reservations-calendar', require('./Reservations/ResourceReservationsCalendar').default);
Vue.component('overview-calendar', require('./Reservations/OverviewCalendar').default);
Vue.component('open-update-reservation-modal-listener', require('./Reservations/OpenUpdateReservationModalListener').default);

const app = new Vue({
    el: '#app'
});
